/**
 * Authentication utilities - shared role hierarchy and permission checks
 */

// Role hierarchy: higher number = more privileges
// platform_admin > firm_admin > firm_user
export const ROLE_HIERARCHY: Record<string, number> = {
  platform_admin: 100,
  firm_admin: 50,
  firm_user: 10,
};

/**
 * Check if user's role meets or exceeds the required role level
 */
export function hasRequiredRole(userRole: string | undefined, requiredRole: string): boolean {
  if (!userRole) return false;

  const userLevel = ROLE_HIERARCHY[userRole];
  const requiredLevel = ROLE_HIERARCHY[requiredRole];

  // Log unexpected roles for debugging
  if (userLevel === undefined) {
    console.warn(`[Auth] Unknown user role: ${userRole}`);
  }
  if (requiredLevel === undefined) {
    console.warn(`[Auth] Unknown required role: ${requiredRole}`);
  }

  return (userLevel ?? 0) >= (requiredLevel ?? 0);
}

/**
 * Check if user has admin-level access (firm_admin or higher)
 */
export function isAdminRole(role: string | undefined): boolean {
  return hasRequiredRole(role, 'firm_admin');
}

/**
 * Check if user is platform admin
 */
export function isPlatformAdmin(role: string | undefined): boolean {
  return role === 'platform_admin';
}
